import "./App.css";
import excel from "./excel.txt";
import React, { useState, useEffect } from "react";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import HikingIcon from '@mui/icons-material/Hiking';
import SnowshoeingIcon from '@mui/icons-material/Snowshoeing';
import WhatshotOutlinedIcon from '@mui/icons-material/WhatshotOutlined';
import { read, utils } from "xlsx";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import MaterialTable from "material-table";
import { ThemeProvider, createTheme } from "@mui/material";
import { MarkerPedestre, MarkerRaquette } from "./Marker";

const defaultMaterialTheme = createTheme();
var excelfile = "";

if (typeof window !== "undefined") {
  // Check if we're running in the browser.

  // ✅ Only runs once per app load
  // Function to read the file content
  await fetch(excel)
    .then((r) => r.text())
    .then((text) => {
      excelfile = text;
    });
}

function MapScroll() {
  const map = useMapEvents({
    click: () => {
      map.scrollWheelZoom.enable();
      /*if (map.scrollWheelZoom.enabled()) {
        map.scrollWheelZoom.disable();
        }
        else {
        map.scrollWheelZoom.enable();
        }
      */
    },
  });
  return null;
}

function capitalizeFirstLetter(string) {
  if(string != undefined && string.length >1)
    return string.charAt(0).toUpperCase() + string.slice(1);
}

//open rando page on click in list.
const handleClickOpen = (rando) => {
  window.open(rando.url, "_blank");
};
function App() {
  const [randos, setRandos] = useState([]);
  const [filteredRandos, setFilteredRandos] = useState([]); // New state for filtered data

  /* Fetch and update the state once */
  useEffect(() => {
    (async () => {
      /* Download file */
      //"https://uploads-ssl.webflow.com/626bd9c789bf78f44f4fe3ff/64e113d30967558a3a12aa12_liste-randonnees.xlsx"
      //"https://uploads-ssl.webflow.com/626bd9c789bf78f44f4fe3ff/650f470ec1a2d98a976a8b40_DATA_Randodze_Carte_Geo.xlsx"
      //excelfile
      const f =
        await //TODO FOR LIVE : A uploaded dans wordpress le fichier excel.
        (
          await fetch(
            excelfile //"https://uploads-ssl.webflow.com/626bd9c789bf78f44f4fe3ff/650f470ec1a2d98a976a8b40_DATA_Randodze_Carte_Geo.xlsx" //"DATA_Randodze_Carte_Geo.xlsx"
          )
        ).arrayBuffer();
      const wb = read(f); // parse the array buffer
      const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
      const data = utils.sheet_to_json(ws); // generate objects

      for(const rando of data){
        rando.type = capitalizeFirstLetter(rando.type);
        rando.niveau = capitalizeFirstLetter(rando.niveau);
      }
      setRandos(data); // update state
      setFilteredRandos(data); // Initialize filtered data with all data
    })();
  }, []);
  const tableRef = React.useRef();

  return (
    <div className="App">
      <MapContainer center={[46.6, 7.20]} zoom={9} scrollWheelZoom={false}>
        <MapScroll />
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {filteredRandos.map((rando, index) => (
          <Marker
            key={index}
            position={[parseFloat(rando.lat), parseFloat(rando.long)]}
            icon={rando.type === "Raquette" ? MarkerRaquette : MarkerPedestre}
          >
            <Popup>
              <div className={(rando.type ==="Raquette"?"raquette":"pedestre")}><h2>{rando.titre}</h2>
              <h3>
                {rando.canton}
              </h3>
              <div>
                <p>{rando.type=== "Raquette"? <SnowshoeingIcon/> : <HikingIcon/>}{rando.type}</p>
                <p><WhatshotOutlinedIcon/>{rando.niveau}</p>
              </div>
              <div>
                <p><AccessTimeIcon />{rando.duree}</p>
                <p><ImportExportIcon />{rando.denivele}</p>
              </div>
              <a href={rando.url.trim()} className="button" target="_blank" rel="noopener noreferrer">
                Voir en détail
              </a>
              </div></Popup>
          </Marker>
        ))}
      </MapContainer>
      <div id="materialtable">
        <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          columns={[
            {
              title: "Canton",
              field: "canton",
              lookup: {
                Argovie: "Argovie",
                "Appenzell Rhodes-Intérieures": "Appenzell Rhodes-Intérieures",
                "Appenzell Rhodes-Extérieures": "Appenzell Rhodes-Extérieures",
                Berne: "Berne",
                "Bâle-Campagne": "Bâle-Campagne",
                "Bâle-Ville": "Bâle-Ville",
                Fribourg: "Fribourg",
                Genève: "Genève",
                Glaris: "Glaris",
                Grisons: "Grisons",
                Jura: "Jura",
                Lucerne: "Lucerne",
                Neuchâtel: "Neuchâtel",
                Nidwald: "Nidwald",
                Obwald: "Obwald",
                "Saint-Gall": "Saint-Gall",
                Schaffhouse: "Schaffhouse",
                Soleure: "Soleure",
                Schwytz: "Schwytz",
                Thurgovie: "Thurgovie",
                Tessin: "Tessin",
                Uri: "Uri",
                Vaud: "Vaud",
                Valais: "Valais",
                Zoug: "Zoug",
                Zurich: "Zurich",
              },
            },
            { title: "Randonnée", field: "titre" },
            {
              title: "Difficulté",
              field: "niveau",
              lookup: {
                Facile: "Facile",
                "Facile-moyen": "Facile-moyen",
                Moyen: "Moyen",
                "Moyen-difficile": "Moyen-difficile",
                Difficile: "Difficile",
              },
            },
            { title: "Durée", field: "duree" },
            { title: "Dénivelé", field: "denivele", filtering: false },
            {
              title: "Boucle/Traversée",
              field: "boucle_traversee",
              lookup: { Boucle: "Boucle", Traversée: "Traversée" },
            },
            {
              title: "Type",
              field: "type",
              lookup: { Pédestre: "Pédestre", Raquette: "Raquette" },
            },
          ]}
          options={{
            filtering: true,
            search: false,
            rowStyle: {
              'fontSize': '14px',
            }
          }}
          data={randos}
          tableRef={tableRef}
          localization={{
            pagination:{
              labelRowsPerPage:'Randonnées par page',
              labelDisplayedRows:'{from}-{to} de {count}',
              labelRowsSelect:'randos'
            }
          }}
          onFilterChange={(e) => {
            setFilteredRandos(tableRef.current.dataManager.filteredData);
          }}
          onRowClick={(event, rowData) => handleClickOpen(rowData)}
          title="Randonnées"
        />
      </ThemeProvider>
      </div>
    </div>
  );
}

export default App;
